export const dialects = [
	{
		'id': '官话方言',
		'name': '官话方言',
		'content': '官话是汉语诸方言中分布最广的一种，是以之为母语的人口最多、分布范围最广的汉语一级方言。\n中国约七成人口以官话为母语，主要分布于北方地区、西北地区和南方的西南地区、江淮地区（江苏中部、安徽中部）以及广西北部、湖南的北部和东南部、江西的沿江地区。官话在江苏省苏州市吴江区的菀坪镇、福建省南平市的延平区以及福州长乐航城街道的琴江满族村等地也以方言岛的形式出现。\n官话作为一个大区，下可分8个次方言，分别是：北京官话、东北官话、冀鲁官话、胶辽官话、中原官话、兰银官话、西南官话、江淮官话。',
		'children': [
			{
				'id': '东北官话',
				'name': '东北官话',
				'content': '东北官话主要分布于黑龙江、吉林、辽宁大部分地区、内蒙古东部以及河北东北部。东北官话具体可分为吉沈片、哈阜片、黑松片，每片又可分为几小片。'
			},
			{
				'id': '中原官话',
				'name': '中原官话',
				'content': '中原官话的分布以河南、江苏徐州、陕西关中、山东南部为中心，覆及山东、河北、河南、山西、江苏、安徽、陕西、甘肃、宁夏、青海、新疆。中原官话的古入声清音声母和次浊声母字今读阴平，古全浊声母字今读阳平是中原官话区的主要特点。'
			},
			{
				'id': '兰银官话',
				'name': '兰银官话',
				'content': '兰银官话主要分布于甘肃、青海、宁夏、新疆的部分地区。分为四片金城片、银吴片、河西片、新疆北疆片。'
			},
			{
				'id': '冀鲁官话',
				'name': '冀鲁官话',
				'content': '冀鲁官话主要分布于河北大部、天津、山东北部和西北部，以及北京市平谷区，山西广灵县，内蒙古宁城县，使用人口约9000余万。冀鲁官话是除东北官话外，与北京官话最为接近的官话。'
			},
			{
				'id': '北京官话',
				'name': '北京官话',
				'content': '北京官话又称华北官话，主要分布于北京、河北北部和内蒙古中部，可分为京师、怀承、朝峰、石克四片。北京官话的使用人口约有1500万。'
			},
			{
				'id': '江淮官话',
				'name': '江淮官话',
				'content': '江淮官话分布于今江苏和安徽的大部、湖北局部、江西部分地区等地，江淮官话使用人口大约为7000万，其中主要分布于安徽省除蚌埠、江苏省除徐州一带以外的长江以北地区、镇江以西九江以东的长江南岸沿江一带。江淮官话自东向西分为通泰片、洪巢片、黄孝片。'
			},
			{
				'id': '胶辽官话',
				'name': '胶辽官话',
				'content': '胶辽官话主要分布于山东省的胶东半岛、辽宁省的辽东半岛和鸭绿江下游地带及江苏省的赣榆县。胶辽官话内分登连片、青州片（青莱片）和盖桓片（营通片）。'
			},
			{
				'id': '西南官话',
				'name': '西南官话',
				'content': '西南官话是流行于中国西南部四川、重庆、贵州、云南、湖北，以及邻近的广西壮族自治区北部、湖南省西部、陕西省南部、缅甸果敢的主要语言，在老挝、越南等地也有部分华人使用。西南官话通常按照地域分为四川话、重庆话、贵州话、云南话、桂柳话、湖北话等。'
			}
		]
	},
	{
		'id': '闽方言',
		'name': '闽方言',
		'content': '闽语主要分布在福建、台湾、海南三省以及广东东部和西南部地区、浙江南部地区、江西东北部地区、广西境内柳州等部分地区。整个闽语区共分为闽南、莆仙、闽东、闽北、闽中等八片，有些片还分为若干小片。闽语约分布于148个县市区，使用人口约7500万人。',
		'children': [
			{
				'id': '莆仙方言',
				'name': '莆仙方言',
				'content': '莆田话，是汉藏语系汉语族闽语支莆仙语（莆仙话）的一种方言。莆仙语，又称兴化语、兴化话、兴化方言、莆仙方言，当地人又称之为本地话，莆田讲的本地话称为莆田话，仙游县讲的本地话也称为仙游话，是分布于福建沿海中东部的地方语言。莆仙话分布于莆田市辖区（荔城区、涵江区、城厢区、秀屿区、乌丘屿）、仙游县以及泉州市泉港区、福清市的部分地区，在莆仙地区和旁边的使用人口约500万，因历史上该地区属于兴化军、兴安州、兴化府，故莆仙话又称为兴化话。以莆仙话为载体的非物质文化遗产有莆仙戏和莆仙木偶戏等。',
			},
			{
				'id': '闽东方言',
				'name': '闽东方言',
				'content': '闽东方言是闽语的一个子方言。主要分南北两大片，北片包括：福安、宁德、霞浦、周宁、寿宁、柘荣、福鼎7个县市，北片方言的代表是福安话；南片包括以福州为中心的闽江下游地区各县市：福州、长乐、福清、闽清、平潭、永泰、屏南、古田、罗源、连江，南片方言的代表是福州话。'
			},
			{
				'id': '闽中方言',
				'name': '闽中方言',
				'content': '闽中方言指位于福建省中部地区，即武夷山脉和戴云山脉之间的沙溪流域；仅限于永安市、三明市区和沙县。东临尤溪、大田两县，北与南平、顺昌相接，西连明溪、清流两县，南与连城、漳平交界的闽中地区所使用的方言的统称，其中以永安话作为闽中方言的代表。\n闽中方言使用范围相对集中，使用人口约五十万余人。闽中方言可大致分为三大片，分别是永安话片、三明话片、沙县话片。但在上个世纪50年代末以后，由于大量的外省人口及本省其他地区的人口迁移到闽中地区，使得闽中方言受到冲击，闽中方言也发生了变化。'
			},
			{
				'id': '闽北方言',
				'name': '闽北方言',
				'content': '闽北方言主要分布于福建省北部古闽之建宁道建州地区，闽北语属于历史最早、影响力较大的闽语之一，由古汉语发展而来，保留了古汉语中众多的语音特点和古汉语词汇、构词方法。闽北语的别称有闽北话、建州话、闽越语、建瓯话。\n以建瓯话为代表，建瓯古时为建安郡、建州、建宁府的治所在地，为闽北政治文化中心，方言为闽北通用，由古汉语发展而来，保留了古汉语中众多的语音特点和古汉语词汇。'
			},
			{
				'id': '闽南方言',
				'name': '闽南方言',
				'content': '闽南语，据传起源于黄河、洛水流域，在西晋时期、唐朝、北宋迁移至福建南部，发祥于福建泉州。现主要分布地除闽南地区和台湾地区外，还广泛分布于闽东北地区、浙东南区、及广东潮汕地区（汕尾、揭阳、汕头、潮州）、粤西地区（湛江、茂名、阳江）、粤港澳大湾区（中山、香港）、海南岛及东南亚的大部分华人社群。'
			}
		]
	},
	{
		'id': '徽方言',
		'name': '徽方言',
		'content': '徽语主要分布于新安江流域的旧徽州府（包括今属江西省的婺源），浙江的旧严州府淳安、建德、遂安、寿昌4县（1958年，淳安、遂安合并为淳安县，寿昌县并入建德县）和临安浙川（绩溪移民聚居形成的方言岛），以及江西的德兴、旧浮梁县（今属景德镇市）等地，计19个县市，位于整个皖南地区的南部。徽语可分为绩歙片、休黟片、祁德片、严州片、旌占片五个片，其中绩歙片、休黟片是徽语的中心地区，其他三片受相邻的吴语、赣语等方言的影响，内部差别较大。'
	},
	{
		'id': '晋方言',
		'name': '晋方言',
		'content': '晋方言，现代汉语方言之一。亦称“晋语”。晋语是中国北方的唯一一个非官话方言。晋语使用人口约6305万，晋语区东起太行山、西近贺兰山、北抵阴山、南至黄河汾渭河谷，是中华文明的重要发源地。\n晋语的主要使用地区有山西省、内蒙古自治区中西部、陕西省北部、河南省黄河以北大部、河北省西部，地跨175个市县。晋语位于黄土高原，地理环境相对封闭，是造成晋语在北方较为独特的原因。晋语核心区主要为太原话（已分化成新老两派）和吕梁话。\n晋方言根据内部差别分为并州（太原、文水等地）、吕梁（汾阳、兴县等地）、上党（长治、黎城等地）、五台（五台、神木等地）、大包（大同、包头等地）、张呼（张家口、呼和浩特等地）、邯新（邯郸、新乡等地）、志延（志丹、延川等地）八个方言片。'
	},
	{
		'id': '湘方言',
		'name': '湘方言',
		'content': '湘语，又称湘方言或湖南话，属汉藏语系汉语族，是汉语七大方言之一，是生活在湘江流域及其支系一带湖湘民系使用的主要语言。湘语分为新湘语和老湘语，新湘语以长沙话为代表，老湘语以双峰话为代表。\n湖南省地区方言，包括湘语、西南官话、赣语、客家语，以及湘乡话、湘南土话这些尚未划定归属的方言。湘语是湖南省的主体方言。湖南省是一个方言复杂地区。湖南省外也有一些湘语方言岛分布。'
	},
	{
		'id': '粤方言',
		'name': '粤方言',
		'content': '粤语，广东地区称为广东话、广府话，广西地区称为白话，是一种声调语言，属汉藏语系汉语族汉语方言。是广东地区广府民系和广西地区白话人的母语。在中国南方的广东中西部、广西东南部及香港、澳门和东南亚的部分国家或地区，以及海外华人社区中广泛使用。\n粤语主要分布在中国华南的广东省中部和西部、广西东南部、香港特别行政区、澳门特别行政区、海南省个别地区以及海外华人社区如澳大利亚、新加坡、北美地区、东南亚等国家处广泛流行，全球使用粤语人数甚多。'
	},
	{
		'id': '吴方言',
		'name': '吴方言',
		'content': '吴语，又称江东话、江南话、江浙话、吴越语。在中国分布于今浙江、江苏南部、上海、安徽南部、江西东北部、福建西北一角（浦城），使用人口九千多万。吴语是汉藏语系汉语语族的一支语言，是汉语七大方言集合之一。\n吴语分为太湖、台州、金衢、上丽、瓯江、宣州六片语片，太湖片为最大语片。\n吴语语音与古汉语标准韵书《切韵》《广韵》等有着良好的对应关系。声母方面，吴语继承唐宋三十六字母框架体系，以保留全部浊音为最主要特征，声母分为全清、次清、全浊、次浊四类，部分地区保留尖团音分化。声调方面，吴语具有仄音之一的入声韵，继承中古汉语整齐四声八调，平上去入四声因声母清浊对立而各分阴阳。'
	},
	{
		'id': '赣方言',
		'name': '赣方言',
		'content': '赣语，汉语方言之一，为江右民系使用的主要语言，使用人口约5500万。赣语是汉语八大语系之一，使用人口多数在江西省境内，主要分布在赣江中下游、抚河流域及鄱阳湖流域以及周边、湘东和闽西北、皖西南、鄂东南和湘西南等地区。另外在浙江、陕西还有少数赣语方言岛。此外，赣州市的石城县、宁都县、兴国县、于都县、瑞金县、会昌县等县也有使用赣方言的乡镇。'
	},
	{
		'id': '客家方言',
		'name': '客家方言',
		'content': '客家语，简称客语，是汉藏语系下汉语族内一种声调语言，是汉族客家民系的共同语言和进行身份辩识的工具之一，是汉语七大方言之一。\n客家语在非正式场合又被称为客家话，按不同口音可分为梅州话、惠阳话、惠州话、河源话、赣南话、汀州话等。部分地区还称土广东话、水源音、涯话、新民话、麼个话、怀远话等。语言学术研究中，以梅县话为代表，现实中惠阳话影响较大。'
	},
	{
		'id': '平话土话',
		'name': '平话土话',
		'content': '平话主要分布在广西壮族自治区内，有“桂北平话”和“桂南平话”之分，其中以桂南为多。除汉族外，也还有个别地区的瑶族、壮族、仫佬族、侗族使用平话。\n湘南土话主要分布在湖南南部永州、郴州地区。粤北土话分布在广东北部韶关地区和粤西北的连州、连南等县市区。平话和土话约分布在59个县市，使用人数约779万人。'
	},
]
